
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeaveTypeGrid extends Serenity.EntityGrid<LeaveTypeRow, any> {
        protected getColumnsKey() { return 'HR.LeaveType'; }
        protected getDialogType() { return LeaveTypeDialog; }
        protected getIdProperty() { return LeaveTypeRow.idProperty; }
        protected getInsertPermission() { return LeaveTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return LeaveTypeRow.localTextPrefix; }
        protected getService() { return LeaveTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}